var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import 'antd/es/style/index.less';
import { runtime } from '../../classes/runtime/Runtime';
import { BrowserModal_ } from '../../classes/runtime/browser/modules/BrowserModal/BrowserModal_';
import { AppStylesheets } from './AppStylesheets';
let GlobalComponents_ = class GlobalComponents_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(AppStylesheets, { app: app }),
            this.browserModal));
    }
    get browserModal() {
        if (!runtime.availablePackages.Lazy && !runtime.solidBrowserRuntime.browserModal.isBrowserModalOpen)
            return null;
        return React.createElement(BrowserModal_, null);
    }
};
GlobalComponents_ = __decorate([
    observer
], GlobalComponents_);
export { GlobalComponents_ };
